import React from 'react';
import DataList from '../DataList';
import { getPrograms, deleteProgram, bulkDeletePrograms, bulkUploadPrograms } from '../../api/data';

const ProgramsList: React.FC = () => {
  const config = {
    title: 'Programs',
    singularName: 'program',
    columns: [
      { key: 'id', label: 'ID' },
      { key: 'name_ar', label: 'Arabic Name' },
      { key: 'name_en', label: 'English Name' },
      { key: 'faculty', label: 'Faculty' },
      {
        key: 'aliases',
        label: 'Aliases',
        render: (value: string[]) => value && value.length > 0 ? value.join(', ') : '-'
      }
    ],
    fetchData: getPrograms,
    deleteItem: deleteProgram,
    bulkDelete: bulkDeletePrograms,
    bulkUpload: bulkUploadPrograms,
    createRoute: '/data/programs/create',
    editRoute: (id: number) => `/data/programs/${id}/edit`
  };

  return <DataList config={config} />;
};

export default ProgramsList;
